import {actionType} from './actionType';
import Api from '../../lib/api';
import Helper from '../../lib/helper';

export function loginsGetList(counterType) {
  return function(dispatch) {
    dispatch({type: actionType.session.loginsGetListPending, payload: null});
    
    Api.loginGetList(counterType)
    .then(result => {
      dispatch({
        type: actionType.session.loginsGetListFulfilled,
        payload: result.raw
      });
    })
    .catch(err => {
      dispatch({
        type: actionType.session.loginsGetListRejected,
        payload: Helper.getErrorMsg(err)
      });
    });
  }
}

export function supervisorGetList(callback=null) {
  return function(dispatch) {
    dispatch({type: actionType.session.supervisorGetListPending, payload: null});
    
    Api.supervisorGetList()
    .then(result => {
      dispatch({
        type: actionType.session.supervisorGetListFulfilled,
        payload: result.raw
      });
      callback && callback(true, result.raw);
    })
    .catch(err => {
      dispatch({
        type: actionType.session.supervisorGetListRejected,
        payload: Helper.getErrorMsg(err)
      });
      callback && callback(false, err);
    });
  }
}

export function authenticate(credential, callback=null) {
  return function(dispatch) {
    dispatch({type: actionType.session.authPending, payload: null});
    
    Api.authenticate(credential)
    .then(result => {
      dispatch({
        type: actionType.session.authFulfilled,
        payload: result
      });
      callback && callback(true, result);
    })
    .catch(err => {
      dispatch({
        type: actionType.session.authRejected,
        payload: Helper.getErrorMsg(err)
      });
      callback && callback(false, err);
    });
  }
}

export function logout(callback=null) {
  return function(dispatch) {
    dispatch({type: actionType.session.logoutPending, payload: null});
    
    Api.logout()
    .then(result => {
      dispatch({
        type: actionType.session.logoutFulfilled,
        payload: null
      });
      callback && callback(true, null);
    })
    .catch(err => {
      dispatch({
        type: actionType.session.logoutRejected,
        payload: Helper.getErrorMsg(err)
      });
      callback && callback(false, err);
    });
  }
}

export function machineGetInfo(callback=null) {
  return function(dispatch) {
    dispatch({type: actionType.session.machineGetInfoPending, payload: null});
    
    Api.posGetMachineInfo()
    .then(result => {
      dispatch({
        type: actionType.session.machineGetInfoFulfilled,
        payload: result
      });
      callback && callback(true, result);
    })
    .catch(err => {
      dispatch({
        type: actionType.session.machineGetInfoRejected,
        payload: Helper.getErrorMsg(err)
      });
      callback && callback(false, err);
    });
  }
}

export function setSystemTime() {
  return {
    type: actionType.session.setSystemTime,
    payload: new Date()
  }
}

export function setSupervisor(id) {
  return {
    type: actionType.session.setSupervisor,
    payload: id
  }
}